import {
  ADD_TOAST_MSG,
  AUTH,
  CHANGE_LAST_VISITED,
  LOGOUT,
  REMOVE_TOAST_MSG,
} from "./authTypes";

const intitalState = {
  token: null,
  user: null,
  toastMsg: null,
  toastMsgType: null,
  isLoading: true,
};

const authReducer = (state = intitalState, action) => {
  switch (action.type) {
    case AUTH:
      return {
        ...state,
        token: action.payload.token,
        user: {
          ...action.payload.userData,
          schedule: action.payload.userData.schedule
            .flat()
            .sort((a, b) => a.slot - b.slot)
            .map((item) =>
              item.subject.length > 1
                ? item.subject[0]._id !== item.subject[1]._id ||
                  item.teacher[0]._id !== item.teacher[1]._id ||
                  item.class[0]._id !== item.class[1]._id
                  ? item.subject.map((sub, i) => {
                      if (action.payload.userData.role === "Faculty") {
                        if (
                          action.payload.userData.courses.some(
                            (crs) => crs === sub.course_code
                          ) &&
                          item.teacher[i].userId ===
                            action.payload.userData.userId
                        ) {
                          return {
                            ...item,
                            teacher: [item.teacher[i]],
                            class: [item.class[i]],
                            subject: [sub],
                            Time: [item.Time[i]],
                          };
                        }
                        return null;
                      } else {
                        if (
                          action.payload.userData.courses.some(
                            (crs) =>
                              crs.class_id === item.class[i]._id &&
                              crs.course_id === sub._id &&
                              crs.faculty_id === item.teacher[i]._id
                          )
                        ) {
                          return {
                            ...item,
                            teacher: [item.teacher[i]],
                            class: [item.class[i]],
                            subject: [sub],
                            Time: [item.Time[i]],
                          };
                        }
                        return null;
                      }
                    })
                  : {
                      ...item,
                      teacher: [item.teacher[0]],
                      class: [item.class[0]],
                      subject: [item.subject[0]],
                    }
                : item
            )
            .flat()
            .filter((item) => item !== null),
        },
        isLoading: false,
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        user: null,
        isLoading: false,
      };
    case CHANGE_LAST_VISITED:
      return {
        ...state,
        user: state?.user
          ? {
              ...state.user,
              last_visited: action.payload,
            }
          : null,
      };
    case REMOVE_TOAST_MSG:
      return {
        ...state,
        toastMsg: null,
        toastMsgType: null,
      };
    case ADD_TOAST_MSG:
      return {
        ...state,
        toastMsg: action.payload.msg,
        toastMsgType: action.payload.type,
      };
    default:
      return state;
  }
};

export default authReducer;
